<div class="alert alert-info w-75 m-auto mt-3 text-center" role="alert"
    *ngIf="HsQueryBaseService.features.length === 0; else editOptionsTemplate">
    {{'DRAW.featureEditor.selectFeatureToEdit' | translateHs }}
</div>
<ng-template #editOptionsTemplate>
    <span class="w-75 text-center bg-primary text-white p-2 rounded mb-2" style="--bs-bg-opacity: .8;"><span
            class="text-decoration-underline">{{'DRAW.featureEditor.selectedFeature' | translateHs }}</span>
        {{'DRAW.featureEditor.featureCanBeEditedbyOptions' | translateHs }}:</span>

    <div class="rounded-0 my-1 draw-buttons d-flex justify-content-center">
        <button *ngFor="let option of editOptions" class="btn btn-sm btn-light btn-outline-primary"
            [ngClass]="{active: selectedType === option }" (click)="selectGeomOperation(option)">
            {{HsLanguageService.getTranslationIgnoreNonExisting('DRAW.featureEditor.editOptions',option, undefined)}}
        </button>
    </div>

    <div *ngIf="selectedType" class="d-flex flex-column align-items-center my-3 w-75 bg-secondary"
        style="--bs-bg-opacity: .02;">
        <div class="d-flex flex-column align-items-center border border-start-0 border-end-0 py-3 w-100">
            {{'DRAW.featureEditor.drawNewFeature' | translateHs }}
            <button *ngIf="selectedType !== 'split'" class="w-50 btn btn-sm btn-light btn-outline-primary"
                (click)="setType('Polygon')" [ngClass]="{active: HsDrawService.type==='Polygon' }"
                [title]="'COMMON.polygon' | translateHs ">
                <i class="icon-polygonlasso"></i>
            </button>
            <button *ngIf="selectedType === 'split'" class="w-50 btn btn-sm btn-light btn-outline-primary"
                [ngClass]="{active: HsDrawService.type==='LineString' }" (click)="setType('LineString')"
                data-toggle="tooltip" [title]="'COMMON.line' | translateHs ">
                <i class="icon-line"></i>
            </button>
            <span class="py-1"> {{'DRAW.featureEditor.orSelectOne' | translateHs }}
            </span>
            <button class="w-50 btn btn-sm btn-light btn-outline-primary" [ngClass]="{active: !HsDrawService.type }"
                (click)="setType(HsDrawService.type)" data-toggle="tooltip" [title]="'COMMON.line' | translateHs ">
                <i class="icon-cursor"></i>
            </button>
        </div>

        <button class="btn btn-primary m-2 w-100" (click)="modify(selectedType)" *ngIf="selectedType"
            [disabled]="HsQueryBaseService.features.length < 2">{{'COMMON.continue' | translateHs }}:
            {{HsLanguageService.getTranslationIgnoreNonExisting('DRAW.featureEditor.editOptions',selectedType,
            undefined)}}</button>
    </div>
</ng-template>